import { Box, Divider, Text } from '@wix/design-system';
import React from 'react';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
export const PremiumDomainTooltipContent = () => {
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "SP3 SP4"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    flexGrow: 1,
    gap: "12px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold",
    skin: "standard",
    light: true
  }, t('domain_search_suite.premium_domains.tooltip.header')), /*#__PURE__*/React.createElement(Text, {
    listStyle: "checkmark",
    light: true,
    size: "small",
    weight: "thin"
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      margin: 0,
      padding: 0
    }
  }, /*#__PURE__*/React.createElement("li", null, t('domain_search_suite.premium_domains.tooltip.bullet_1')), /*#__PURE__*/React.createElement("li", null, t('domain_search_suite.premium_domains.tooltip.bullet_2')), /*#__PURE__*/React.createElement("li", {
    style: {
      marginBottom: 0
    }
  }, t('domain_search_suite.premium_domains.tooltip.bullet_3'))))), /*#__PURE__*/React.createElement(Box, {
    margin: "12px 0"
  }, /*#__PURE__*/React.createElement(Divider, {
    skin: "dark"
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    skin: "standard",
    size: "tiny",
    weight: "thin",
    light: true
  }, t('domain_search_suite.premium_domains.tooltip.footer'))));
};
//# sourceMappingURL=PremiumDomainTooltipContent.js.map